export const userContentDismissalQueryKey = (namespace: string, name: string) => ['userContentDismissals', namespace, name] as const;

export const HOMEPAGE_GETTING_STARTED_DISMISSAL_NAMESPACE = 'homepage-getting-started';

export type HomepageGettingStartedCardId = 'invite_team' | 'give_recognition' | 'learn_pricing';

export const homepageGettingStartedDismissalQueryKey = (cardId: HomepageGettingStartedCardId) =>
	userContentDismissalQueryKey(HOMEPAGE_GETTING_STARTED_DISMISSAL_NAMESPACE, cardId);
